<script lang="ts">
    import Select from "svelte-select"
    import { _ } from "svelte-i18n"
    import DocumentTemplate from "../widgets/document-template.svelte"
    import { templateSources } from "../../functions/templates/helper"
    export let lang: string
    let shownTemplate = "offer"

    let selectedTemplateSource: { value: any; label: string; img: string } = { value: null, label: "Standard", img: "" }
</script>

<div class="container address-tabs" style="margin-top: 80px;">
    <div class="row tabs" style="gap: 20px; flex-wrap: nowrap;" data-cy="billing-address-row">
        <div class="col-md-6" style="padding: 0px; width: 0px; flex-grow: 1;">
            <div style="width:100%;" data-cy="operation-offer-radio">
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="tab"
                    class:active="{shownTemplate === 'offer'}"
                    data-cy="company"
                    on:click="{() => {
                        shownTemplate = 'offer'
                    }}"
                    on:keydown
                >
                    {$_("components.documentTemplate.offerTemplate")}
                </div>
            </div>
        </div>
        <div class="col-md-6" style="padding: 0px; width: 0px; flex-grow: 1;">
            <div style="width: 100%;" data-cy="operation-confirmation-radio">
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="tab"
                    class:active="{shownTemplate === 'orderConfirmation'}"
                    data-cy="company"
                    on:click="{() => {
                        shownTemplate = 'orderConfirmation'
                    }}"
                    on:keydown
                >
                    {$_("components.documentTemplate.orderConfirmationTemplate")}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container address-tabs" style="">
    <Select items="{templateSources}" bind:value="{selectedTemplateSource}" showChevron="{true}" clearable="{false}">
        <div slot="item" let:item style="display: flex; align-items: center;">
            <div class="icon">
                <img src="{item.img}" width="18" alt="" />
            </div>
            <span style="margin-left: 10px;"> {item?.label}</span>
        </div>
        <div slot="prepend" style="margin-right: 10px; display: flex; align-items: center;">
            <div class="icon">
                <img src="{selectedTemplateSource.img}" width="18" alt="" />
            </div>
        </div>
    </Select>
</div>
{#key selectedTemplateSource}
    {#if shownTemplate == "orderConfirmation"}
        <DocumentTemplate
            title=" {$_('components.documentTemplate.orderConfirmationTemplate')}"
            type="orderConfirmation"
            {lang}
            selectedSource="{selectedTemplateSource}"
        />
    {:else if shownTemplate == "offer"}
        <DocumentTemplate
            title="{$_('components.documentTemplate.offerTemplate')}"
            type="offer"
            {lang}
            selectedSource="{selectedTemplateSource}"
        />
    {/if}
{/key}
